import React from "react";
import { Dialog } from "primereact/dialog";
import AnttButton from "../../../vendors/components/Button";
import ModalLoginInterno from "../modal-login-interno";

import "./index.scss";
import { useHistory } from "react-router-dom";

interface Props {
  visible: any;
  onHide: any;
  dispositivoLogin: any;
  isEventoInterno?: boolean;
  onLoginSuccess?: (dispositivo: any) => void;
}

export default function ModalLogin({
  visible,
  onHide,
  dispositivoLogin,
  isEventoInterno,
  onLoginSuccess,
}: Props) {
  const history = useHistory();

  if (isEventoInterno) {
    return (
      <ModalLoginInterno
        visible={visible}
        onHide={onHide}
        dispositivoLogin={dispositivoLogin}
        onLoginSuccess={(dispositivo) => onLoginSuccess?.(dispositivo)}
      />
    );
  }

  return (
    <Dialog
      style={{ width: "500px" }}
      header="Faça seu login"
      visible={visible}
      draggable={false}
      onHide={() => onHide()}
    >
      <div className="flex flex-column">
        <AnttButton
          className="gov-br"
          onClick={() => history.push("/login/unico", dispositivoLogin)}
          label="Entrar com gov.br"
        />
      </div>
    </Dialog>
  );
}
